import type { Component } from 'solid-js';
import { type ReportConcernContext, openReportConcern } from '../lib/reportConcern';
import { hideFamilyContent } from '../state/familyContentVisibility';

type Props = {
  context: ReportConcernContext;
  class?: string;
  label?: string;
  role?: 'menuitem';
  onHide?: () => void;
};

export const ReportContentButton: Component<Props> = (props) => (
  <span class="family-content-actions">
    <button
      type="button"
      role={props.role}
      class={props.class ?? 'ghost report-content-button'}
      aria-label={`Report ${props.context.label}`}
      onClick={(event) => {
        event.stopPropagation();
        openReportConcern(props.context);
      }}
    >
      {props.label ?? 'Report'}
    </button>
    <button
      type="button"
      class={props.class ?? 'ghost report-content-button'}
      aria-label={`Hide ${props.context.label}`}
      onClick={(event) => {
        event.stopPropagation();
        if (confirm(`Hide ${props.context.label} from your view on this device?`)) {
          hideFamilyContent(props.context.contentLocalId);
          props.onHide?.();
        }
      }}
    >
      Hide
    </button>
  </span>
);
